import { axiosGet, axiosPost } from '../../../../react_axios/Axios';
import {
    headers,
    getPRAgencyMasterListUrl,
    insertUpdatePRAgencyMasterUrl,
    deletePRAgencyMasterUrl,
    GET_PR_AGENCY_MASTER_LIST,
    INSERT_UPDATE_PR_AGENCY_MASTER,
    DELETE_PR_AGENCY_MASTER,
} from '../../../../utils/constants';

export const getPRAgencyMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getPRAgencyMasterListUrl, params, headers);
        dispatch({ type: GET_PR_AGENCY_MASTER_LIST, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const insertUpdatePRAgencyMaster_action = (formData) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ...formData,
        };
        const res = await axiosPost(insertUpdatePRAgencyMasterUrl, params, headers);
        dispatch({ type: INSERT_UPDATE_PR_AGENCY_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deletePRAgencyMaster_action = (PRAgencyID) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            PRAgencyID,
        };
        const res = await axiosGet(deletePRAgencyMasterUrl, params, headers);
        dispatch({ type: DELETE_PR_AGENCY_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
